var list = [
  { value: 'ar', text: 'Arabic', dateFormat: 'ar' },
  { value: 'zh_CN', text: 'Chinese (China)', dateFormat: 'zh-CN' },
  { value: 'zh_TW', text: 'Chinese (Taiwan)', dateFormat: 'zh-TW' },
  { value: 'cs', text: 'Czech', dateFormat: 'cs' },
  { value: 'nl', text: 'Dutch', dateFormat: 'nl' },
  { value: 'en', text: 'English (US)', dateFormat: 'en-US' },
  { value: 'en_GB', text: 'English (GB)', dateFormat: 'en-GB' },
  { value: 'fa', text: 'Farsi', dateFormat: 'fa' },
  { value: 'fr', text: 'French', dateFormat: 'fr' },
  { value: 'de', text: 'German', dateFormat: 'de' },
  { value: 'el', text: 'Greek', dateFormat: 'el' },
  { value: 'it', text: 'Italian', dateFormat: 'it' },
  { value: 'he', text: 'Hebrew', dateFormat: 'iw' },
  { value: 'hu', text: 'Hungarian', dateFormat: 'hu' },
  { value: 'pl', text: 'Polish', dateFormat: 'pl' },
  { value: 'pt', text: 'Portuguese', dateFormat: 'pt' },
  { value: 'ro', text: 'Romanian', dateFormat: 'ro' },
  { value: 'ru', text: 'Russian', dateFormat: 'ru' },
  { value: 'es_419', text: 'Spanish (Latin America)', dateFormat: 'es-419' },
  { value: 'es_ES', text: 'Spanish (Spain)', dateFormat: 'es-ES' },
  { value: 'tr', text: 'Turkish', dateFormat: 'tr' },
  { value: 'ja', text: 'Japanese', dateFormat: 'ja' },
  { value: 'th', text: 'Thai', dateFormat: 'th' },
  { value: 'ko', text: 'Korean', dateFormat: 'ko' },
  { value: 'vi', text: 'Vietnamese', dateFormat: 'vi' },
  { value: 'id', text: 'Indonesian', dateFormat: 'id' }
];

function getBroswerLanguage() {
  // var userLang = navigator.language || navigator.userLanguage;
  // var index = userLang.indexOf('-');
  // if (index > -1) {
  //     userLang = userLang.substring(0, index);
  // }
  //return userLang;
  return 'en';
}

function getLanguage(langCode) {
  var language = null;
  language = list.filter(lang => lang.value === langCode);
  if (language.length > 0) {
    language = language[0];
  }
  return language;
}

export { list, getBroswerLanguage, getLanguage };
